<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<div
  class="container"
  [ngClass]="{
    'content-wrapper': contentfulCategory?.backgroundImageAssetId && contentfulCategory?.backgroundImageAssetUrl
  }"
>
  <div
    class="text-content-wrapper row content-vertical-center"
    [ngClass]="{
      'content-horizontal-left': aligned === 'left',
      'content-horizontal-right': aligned === 'right'
    }"
  >
    <div class="inner-wrapper" [ngClass]="{ 'white-text': whiteText || contentfulCategory?.heroImageUrl }">
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
      <div
        class="inner-wrapper-text"
        [ngClass]="{
          'text-start': contentfulCategory?.backgroundImageAssetUrl,
          'text-center': !contentfulCategory?.backgroundImageAssetUrl
        }"
        [ngStyle]="{ 'max-height': disclaimerMaxHeight, 'margin-bottom': disclaimerHeight + 'px' }"
      >
        @if (contentfulCategory?.surtitle) {
          <div class="contentful-article-breadcrumb__item" [innerHTML]="contentfulCategory?.surtitle"></div>
        } @else {
          @if (articleBreadcrumbs && contentfulCategory?.shortName) {
            <div>
              <a class="contentful-article-breadcrumb__item" [routerLink]="articleBreadcrumbs.path">
                {{ articleBreadcrumbs.label }}
              </a>
            </div>
          }
        }

        <app-contentful-category-title [contentfulCategory]="contentfulCategory" />
        @if (contentfulCategory?.description) {
          <div
            class="paragraph-text"
            [ngClass]="{ container: !contentfulCategory?.backgroundImageAssetUrl }"
            [innerHTML]="contentfulCategory!.description! | sanitizeContentfulHTML"
          ></div>
        }
      </div>
      @if (contentfulCategory?.callToActionLabel) {
        <div [ngClass]="{ 'cta-block': index === 0, 'landing-button-container': index !== 0 }">
          <div [ngClass]="{ cta: index === 0, 'text-center': index !== 0 }">
            @if (contentfulCategory?.callToActionLink && contentfulCategory?.callToActionLink?.[0] === '/') {
              <a
                [href]="contentfulCategory?.callToActionLink"
                [ngClass]="{
                  'see-more-link': index === 0,
                  'landing-button': index !== 0,
                  'border-white': whiteText || contentfulCategory?.heroImageUrl
                }"
              >
                <span
                  [ngClass]="{
                    'link-text': index === 0,
                    'white-text': (index !== 0 && whiteText) || contentfulCategory?.heroImageUrl
                  }"
                >
                  @if (index === 0) {
                    <img
                      class="link-chevron-right"
                      alt="chevron-right"
                      [src]="'assets/images/icons/chevron-right.svg' | staticFileHash"
                    />
                  }
                  {{ contentfulCategory?.callToActionLabel }}
                </span>
              </a>
            }

            @if (contentfulCategory?.callToActionLink && contentfulCategory?.callToActionLink?.[0] === '#') {
              <a
                [fragment]="contentfulCategory?.callToActionLink?.substring(1)"
                [routerLink]="[]"
                [ngClass]="{
                  'see-more-link': index === 0,
                  'landing-button': index !== 0,
                  'border-white': whiteText || contentfulCategory?.heroImageUrl
                }"
              >
                <span
                  [ngClass]="{
                    'link-text': index === 0,
                    'white-text': (index !== 0 && whiteText) || contentfulCategory?.heroImageUrl
                  }"
                >
                  @if (index === 0) {
                    <img
                      class="link-chevron-right"
                      alt="chevron-right"
                      [src]="'assets/images/icons/chevron-right.svg' | staticFileHash"
                    />
                  }
                  {{ contentfulCategory?.callToActionLabel }}
                </span>
              </a>
            }
          </div>
        </div>
      }
    </div>
    @if (contentfulCategory?.disclaimer) {
      <div #disclaimerMessage class="disclaimer-message">
        {{ contentfulCategory?.disclaimer }}
      </div>
    }
  </div>
</div>
